import { render, staticRenderFns } from "./ProductOverviewFilter.vue?vue&type=template&id=427db7bd&"
import script from "./ProductOverviewFilter.vue?vue&type=script&lang=ts&"
export * from "./ProductOverviewFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports